var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 20 21",
    fill: "currentColor"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.333 3.77a5.083 5.083 0 100 10.167 5.083 5.083 0 000-10.166zM1.75 8.855a6.583 6.583 0 1113.167 0 6.583 6.583 0 01-13.167 0z",
    fill: "#48525C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.97 12.49a.75.75 0 011.06 0l5 5a.75.75 0 11-1.06 1.06l-5-5a.75.75 0 010-1.06z",
    fill: "#48525C"
  })));
};
export default SvgSearch;